// extracted by mini-css-extract-plugin
export default {"shift-preset-day":"shift-preset-day--gr7rQ event-month--atv6w","shiftPresetDay":"shift-preset-day--gr7rQ event-month--atv6w"};